<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Vouchers', route: '/backoffice/vouchers' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <div>
            <h2>Elenco vouchers</h2>
            <span class="ac-meta">gestione codici e crediti</span>
        </div>
    </div>

    <p-table #dt
        [exportFilename]="'vouchers'"
        [columns]="[{field: 'cliente', header: 'Cliente'}, {field: 'email', header: 'Email'}, {field: 'telefono', header: 'Telefono'}, {field: 'codice', header: 'Codice'}, {field: 'credito', header: 'Credito'}, {field: 'data_scadenza', header: 'Data scadenza'}, {field: 'data_creazione', header: 'Data creazione'}]"
        [loading]="loading"
        [value]="vouchers"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [rowHover]="true"
        [globalFilterFields]="['cliente', 'email', 'codice']"
        currentPageReportTemplate="{first} di {last} su {totalRecords} vouchers"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20, 50, 100]">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full items-stretch">
                <input type="text" pInputText class="flex-1" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca voucher…" />
                <div class="table-toolbar-btns">
                    <button class="acc-btn" type="button" (click)="dt.exportCSV()">
                        <i class="bi bi-file-spreadsheet"></i>
                        Esporta
                    </button>
                    <a class="acc-btn acc-btn-primary" routerLink="/backoffice/vouchers/add">
                        <i class="bi bi-plus"></i>
                        Aggiungi voucher
                    </a>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="cliente">Cliente <span class="inline-flex"><p-sortIcon field="cliente" /></span></th>
                <th pSortableColumn="email">Email <span class="inline-flex"><p-sortIcon field="email" /></span></th>
                <th pSortableColumn="codice">Codice <span class="inline-flex"><p-sortIcon field="codice" /></span></th>
                <th pSortableColumn="credito">Credito <span class="inline-flex"><p-sortIcon field="credito" /></span></th>
                <th pSortableColumn="data_scadenza">Data scadenza <span class="inline-flex"><p-sortIcon field="data_scadenza" /></span></th>
                <th class="text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-voucher>
            <tr>
                <td>
                    <span class="p-column-title">Cliente</span>
                    <span class="cell-nome">{{voucher.cliente | titlecase}}</span>
                </td>
                <td>
                    <span class="p-column-title">Email</span>
                    {{voucher.email | lowercase}}
                </td>
                <td>
                    <span class="p-column-title">Codice</span>
                    {{voucher.codice}}
                </td>
                <td>
                    <span class="p-column-title">Credito</span>
                    {{voucher.credito | currency: 'EUR' }}
                </td>
                <td>
                    <span class="p-column-title">Data scadenza</span>
                    {{voucher.data_scadenza | date: 'dd/MM/yyyy' }}
                </td>
                <td class="text-center">
                    <div class="table-actions">
                        <i class="bi bi-pencil" [routerLink]="'/backoffice/vouchers/' + voucher.id"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteVoucher>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeleteVoucher()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteVoucher()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeleteVoucher($event, voucher)"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6">Nessun voucher trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>
